import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { Role } from '../../../pages/users/user.model';
import { UsersService } from '../../../pages/users/users.service';

@Component({
  selector: 'app-multi-select-role',
  templateUrl: './multi-select-role.component.html',
  styleUrls: ['./multi-select-role.component.scss'],
  providers: [ UsersService ]
})
export class MultiSelectRoleComponent implements OnInit {
  public roles: Role[];
  public roleId: number;
  public rolesId = new FormControl();
  @Output() public onChangeRole: EventEmitter<any> = new EventEmitter<any>();

  constructor(private usersService: UsersService) {

  }

  ngOnInit() {
    this.usersService.getRoles().subscribe(roles => {
      this.roles = roles;
    });
  }

  getNameRole(roleId){
    return this.roles.find(x => x.id == roleId).name;
  }

  onChange() {
    this.onChangeRole.emit();
  }

}
